"use client";
import * as t from "react";
const n = /* @__PURE__ */ t.createContext(void 0);
process.env.NODE_ENV !== "production" && (n.displayName = "NavigationMenuItemContext");
function a() {
  const e = t.useContext(n);
  if (e === void 0)
    throw new Error("Base UI: NavigationMenuItem parts must be used within a <NavigationMenu.Item>.");
  return e;
}
export {
  n as N,
  a as u
};
